import { render, staticRenderFns } from "./DataEditor.vue?vue&type=template&id=08fe6054&"
import script from "./DataEditor.vue?vue&type=script&lang=js&"
export * from "./DataEditor.vue?vue&type=script&lang=js&"
import style0 from "./DataEditor.vue?vue&type=style&index=0&id=08fe6054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports